import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { formatTL } from "@/lib/api";
import { Card } from "@/components/ui/card";

const Table = ({ title, rows, k, testid }) => (
  <Card className="p-4" data-testid={testid}>
    <div className="text-sm font-semibold mb-2">{title}</div>
    {rows.length === 0 ? <div className="text-xs text-slate-400">Veri yok</div> : (
      <table className="w-full text-sm"><tbody>{rows.map((r) => (
        <tr key={r[k]} className="border-t"><td className="py-1.5">{r.label || r[k]}</td><td className="py-1.5 text-right font-semibold">{formatTL(r.amount)}</td></tr>
      ))}</tbody></table>
    )}
  </Card>
);

export function FinCharts({ s }) {
  if (!s) return null;
  return (
    <div className="grid xl:grid-cols-[2fr_1fr] gap-4">
      <Card className="p-4" data-testid="fin-chart">
        <div className="text-sm font-semibold mb-2">Gelir / gider karşılaştırması</div>
        <div className="h-72">
          <ResponsiveContainer>
            <BarChart data={s.series}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis dataKey="bucket" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip formatter={(v) => formatTL(v)} />
              <Legend />
              <Bar dataKey="income" name="Gelir" fill="#047857" radius={[4, 4, 0, 0]} />
              <Bar dataKey="expense" name="Gider" fill="#ef4444" radius={[4, 4, 0, 0]} />
              <Bar dataKey="refund" name="İade" fill="#f59e0b" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Card>
      <Table title="İşlem türüne göre" rows={s.by_type} k="type" testid="fin-by-type" />
      <Table title="Şehre göre" rows={s.by_city} k="city" testid="fin-by-city" />
      <Table title="Ofise göre (ilk 15)" rows={s.by_office} k="office" testid="fin-by-office" />
    </div>
  );
}
